import React from 'react';
import styled from 'styled-components';
import { Palette } from '../utils';

export function Card({
  height,
  width,
  background,
  borderRadius,
  padding,
  margin,
  onClick,
  cssOverride,
  children
}) {
  return (
    <StyledCard
      height={height}
      width={width}
      background={background}
      borderRadius={borderRadius}
      padding={padding}
      margin={margin}
      onClick={onClick}
      cssOverride={cssOverride}>
      {children}
    </StyledCard>
  );
}

export const StyledCard = styled.div`
  background: ${({ background }) => background || Palette.WHITE};
  border: none;
  box-shadow: 0px 4px 70px rgba(0, 0, 0, 0.06);
  border-radius: ${({ borderRadius }) => borderRadius || '20px'};
  height: ${({ height }) => height || '100%'};
  width: ${({ width }) => width || '100%'};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};

  ${({ cssOverride }) => cssOverride};
`;
